import axios from "axios";
import { auth, db } from "../../../config/firebase/firebase-config";
import { firebaseApiResponse } from "../../../interfaces/firebase";
import { IAuthDoc } from "../doc/IAuthDoc";
import { IAuthChangePassword } from "../doc/IAuthChangePassword";
import { IUserLoggedIn } from "../../../redux/types/types";

//
export const saveEmailPasswordFirebase = async (data: IAuthDoc) => {
  try {
    return await auth.createUserWithEmailAndPassword(
      data.email,
      data.password.toString()
    );
  } catch (error) {
    throw error; // Lanza el error capturado
  }
};

export const saveEmailPasswordService = async (
  dataAuth: IAuthDoc
): Promise<firebaseApiResponse> => {
  //CREAR EL USUARIO MEDIANTE EL API
  const { email, password } = dataAuth;

  return axios
    .post(
      `${process.env.REACT_APP_URL_AUTH_UNIVERSAL_TOKEN}:signUp?key=${process.env.REACT_APP_FIREBASE_SERVER_KEY}`,
      { email, password, returnSecureToken: true }
    )
    .then((resp: any) => {
      const { data } = resp;
      return data as firebaseApiResponse;
    })
    .catch((error) => {
      console.error("Error signing up:", error);
      throw error;
    });
};

export const updateCredentialsEntityService = (
  dataChange: IAuthChangePassword
): Promise<firebaseApiResponse | any> => {
  //HACER EL CAMBIO MEDIANTE EL API REST PARA NO GENERAR UNA NUEVA SESION EN LA APP
  const { email, newPassword, oldPassword } = dataChange;

  return axios
    .post(
      `${process.env.REACT_APP_URL_AUTH_UNIVERSAL_TOKEN}:signInWithPassword?key=${process.env.REACT_APP_FIREBASE_SERVER_KEY}`,
      { email: email, password: oldPassword, returnSecureToken: true }
    )
    .then((response) => {
      const { data } = response;
      const { idToken } = data;

      // Petición para cambiar la contraseña
      return axios
        .post(
          `${process.env.REACT_APP_URL_AUTH_UNIVERSAL_TOKEN}:update?key=${process.env.REACT_APP_FIREBASE_SERVER_KEY}`,
          {
            idToken,
            password: newPassword,
            returnSecureToken: true,
          }
        )
        .then((resp) => {
          const { data } = resp;
          return data;
        })
        .catch((error) => {
          console.error("Error cambiando la contraseña:", error);
          throw new Error(
            "No se pudo cambiar la contraseña. Intente de nuevo más tarde."
          );
        });
    })
    .catch((error) => {
      console.error("Error iniciando sesión:", error);
      throw new Error("Usuario no regsitrado en Authentication.");
    });
};

export const getUserData = (email: string): Promise<IUserLoggedIn | null> => {
  return db
    .collection("Users")
    .where("email", "==", email)
    .limit(1)
    .get()
    .then((snap) => {
      let response: IUserLoggedIn | null = null;
      snap.forEach((doc) => {
        response = doc.data() as IUserLoggedIn;
      });
      return response;
    });
};

export const registerWithEmailPassword = async (
  email: string,
  password: string
): Promise<firebaseApiResponse> => {
  //CREAR EL USUARIO MEDIANTE EL API

  return axios
    .post(
      `${process.env.REACT_APP_URL_AUTH_UNIVERSAL_TOKEN}:signUp?key=${process.env.REACT_APP_FIREBASE_SERVER_KEY}`,
      { email, password, returnSecureToken: true }
    )
    .then((resp: any) => {
      const { data } = resp;
      return data as firebaseApiResponse;
    });
};

export const RecoverPassword = async (email: string) => {
  try {
    await auth.sendPasswordResetEmail(email);
    return true;
  } catch {
    return false; // Lanza el error capturado
  }
};

export const deleteFirebaseUser = async (uid: string) => {
  const payload = {
    uid: uid, // Se envía directamente, sin un objeto anidado
  };
    try {
      const response = await axios.post(`${process.env.REACT_APP_URL_FUNCTION}/deleteUidAuth`, payload, {
        headers: { "Content-Type": "application/json" },
      });
  
      return {
        success: true,
        status: response.status,
        data: response.data,
      };
    } catch (error: any) {
      console.error("Error al eliminar usuario:", error);
  
      return {
        success: false,
        status: error.response?.status || 500,
        data: error.response?.data || "Error desconocido al eliminar usuario.",
      };
    }
};
